import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"ma-6",attrs:{"flat":""}},[_c('view-title',{attrs:{"title":"Payments Management"}}),_c('payments-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }